<template>
  <div class="container">
    <div class="body">
      <headerDiv @getIsshow="getIsshow" />
      <div class="total" >
        <!-- v-show="Banner" -->
        <div class="one">
          <p>{{ $t("login.one") }}</p>
          <div class="two" style="margin-top: 35px">
            <input type="text" :placeholder="$t('login.NameUser')" v-model="Uid" />
          </div>
          <div class="two">
            <input
              type="password"
              name=""
              id=""
              v-model="Pwd"
              :placeholder="$t('login.UserPwd')"
            />
          </div>
          <div class="three">
            <input type="text" :placeholder="$t('login.YzCode')" v-model="code" />
            <div class="code" id="v_container"></div>
          </div>
          <div class="four">
            <button type="button" @click="denglu()">
              <span>{{ $t("login.three") }}</span>
              <img src="../../../assets/images/xiangyoujiantou.png" alt="" />
            </button>
          </div>
          <p class="pdw" @click="xs()">{{ $t("login.two") }}</p>
          <div class="five">
            <span>{{ $t("login.four") }}</span>
            <span @click="register()">{{ $t("login.five") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div >
        <!-- <div class="jt1" @click="sds" id="positon" v-if="Show">
          <img
            src="../../../assets/images/jtz.png"
            alt=""
            style="width: 75%; margin: 5px 0 0 5px"
          />
        </div> -->
        <!-- <Drawer :closable="false" v-model="value1" :mask="false" :scrollable="true">
          <div id="floatDivBoxs">
            <div class="floatDtt">在線客服</div>
            <div class="floatShadow">
              <ul class="floatDqq">
                <li style="padding-left: 0px">
                
                    <img
                      src="../../../assets/images/whatsapp.png"
                      height="16"
                      border="0"
                      alt="whatsapp"
                      align="absmiddle"
                    />
               
                </li>
                <li style="padding-left: 0px">
                  <a
                    href="https://m.me/10533192155084"
                    target="_blank"
                  >
                    <img
                      src="../../../assets/images/whatsapp.png"
                      height="16"
                      border="0"
                      alt="whatsapp"
                      align="absmiddle"
                    />
                    &nbsp;&nbsp;享衢集運</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </Drawer> -->
    </div>
    <Modal
      v-model="handelModal"
      title="忘記密碼"
      width="400px"
      class-name="vertical-center-modal"
    >
      <!-- <div class="block" style="margin: 10px 0 0 0;">
        {{$t('login.member')}}ID：<Input v-model="from.MemberId" placeholder="請輸入妳的會員ID" style="width: 300px" />
      </div> -->
      <div class="block" style="margin: 10px 0 0 0">
        {{ $t("login.yh") }}：<Input
          v-model="from.clientName"
          placeholder="請輸入妳的手機號"
          style="width: 300px"
        />
      </div>
      <div class="block" style="margin: 10px 0 0 0">
        {{ $t("login.ela") }}：&nbsp;&nbsp;&nbsp;&nbsp;<Input
          v-model="from.email"
          placeholder="請輸入妳的郵箱"
          style="width: 300px"
        />
      </div>
      <div style="margin: 5px 0 0 270px">
        <Button type="primary" @click="Client_ReSetPwd()">找回密碼</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
import axios from "axios";
import headerDiv from "../../layout/header/index.vue";
import { GVerify } from "./code.js";
import md5 from "js-md5";
export default {
  data() {
    return {
      username: "",
      userpwd: "",
      single: false,
      four: 0,
      one: true,
      two: false,
      Uid: localStorage.getItem("Uid"),
      Pwd: localStorage.getItem("Pwd"),
      code: "",
      verifyCode: "",
      handelModal: false,
      // Cname:"",
      // Cphone:"",1122231@qq.com  113282
      from: {
        // MemberId: localStorage.getItem("userID"),
        clientName: "",
        email: "",
      },
      all: {},
      Banner: false,
       value1: true,
      // list:{}
    };
  },
  components: {
    headerDiv,
  },
  watch: {
    $route(newValue, oldValue) {
      if (this.$route.query.Code) {
        this.Banner = true;
      }
    },
  },
  methods: {
    xs() {
      this.handelModal = true;
    },
    async Client_ReSetPwd() {
      if (this.from.clientName == "") {
        this.$Message.error("請輸入您的用戶名");
        return false;
      } else if (this.from.email == "") {
        this.$Message.error("請輸入您的郵箱");
        return false;
      } else {
        const { data } = await this.$post("Client_ReSetPwd", this.from);
        if (data.State) {
          this.$Message.success('您的新密碼重置為"123456"');
        } else {
          this.all = data.ReturnJson;
          this.$Message.error(this.all);
          console.log(this.all);
        }
        this.handelModal = false;
      }
    },
    getIsshow(data) {
      this.Banner = data;
    },
    async queryUrl() {
      const _md5 = md5('{"Url":"member.hengqujy.com"}123456');
      const params = {
        JsonData: '{"Url":"member.hengqujy.com"}',
        CusID: 23,
        KeyMd5: _md5,
      };
      const { data } = await this.$post("/QueryUrl", params, true);
      if (data.State) {
        const storeInfo = JSON.parse(data.ReturnJson);
        // console.log(this.list = JSON.parse(data.ReturnJson).imgurl)
        localStorage.setItem("CusID", storeInfo.CusID);
        localStorage.setItem("shopName", storeInfo.Name);
        document.title = storeInfo.Name;
        localStorage.setItem("KeyText", storeInfo.KeyText);
        localStorage.setItem("phone", storeInfo.Phone);
        localStorage.setItem("TaoBaoUrl", storeInfo.TaoBaoUrl);
      }
    },
    async Client_Login_NoMd5(Uid, Pwd) {
      const KeyText = localStorage.getItem("KeyText");
      const JsonData = {
        Uid: Uid || this.Uid,
        Pwd: Pwd,
      };
      const _md5 = md5(JSON.stringify(JsonData) + KeyText); // md5加密
      const params = {
        JsonData: JSON.stringify(JsonData),
        CusID: localStorage.getItem("CusID") || 23,
         KeyMd5: _md5,
      };
      // alert(JSON.stringify(params))
      const { data } = await this.$post("/Client_Login_NoMd5", params, true);
      if (data.State) {
        const msg = JSON.parse(data.ReturnJson);
        localStorage.setItem("token", msg.Token);
        localStorage.setItem("userID", msg.id);
        localStorage.setItem("name", msg.ClientName);
        console.log(localStorage.setItem("userID", msg.id));
        localStorage.removeItem("guide");
        this.$Message.success("登錄成功");
        this.$router.push("./manageHome");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    async login() {
      const pwd = Base64.encode(this.Pwd);
      const KeyText = localStorage.getItem("KeyText");
      const JsonData = {
        Uid: this.Uid,
        Pwd: pwd,
      };
      const _md5 = md5(JSON.stringify(JsonData) + KeyText); // md5加密
      const params = {
        JsonData: JSON.stringify(JsonData),
        CusID: localStorage.getItem("CusID"),
        KeyMd5: _md5,
      };
      const { data } = await this.$post("/Client_Login", params, true);
      if (data.State) {
        const msg = JSON.parse(data.ReturnJson);
        localStorage.setItem("token", msg.Token);
        localStorage.setItem("userID", msg.id);
        localStorage.setItem("name", msg.ClientName);
        localStorage.setItem("name", msg.ClientName);
        localStorage.setItem("Uid", this.Uid);
        localStorage.setItem("Pwd", this.Pwd);
        sessionStorage.removeItem("guide");
        this.$Message.success("登錄成功");
        
        this.$router.push("./manageHome");
      } else {
        this.$Message.error(data.MsgText);
      }
    },
    denglu() {
      if (this.Uid == "") {
        this.$Message.error("用戶名不能為空!");
        return false;
      }
      if (this.Pwd == "") {
        this.$Message.error("密碼不能為空!");
        return false;
      }
      if (this.verifyCode != "") {
        this.$Message.error("验证码不能为空!");
        return false;
      }
      this.login();
    },
    register() {
      console.log("123222");
      this.$router.push("./register");
    },
  },
  created() {
    this.queryUrl();
    if (this.$route.query && this.$route.query.Pwd) {
      let { Uid, Pwd } = this.$route.query;
      this.Client_Login_NoMd5(Uid, Pwd);
    }
  },
  mounted() {
    const codeImg = new GVerify("v_container");
    // this.verifyCode = codeImg.options.code;
    console.log(this.verifyCode);
    if (this.$route.query.Code) {
      this.Banner = true;
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-drawer-content {
  box-shadow: none !important;
  background-color: #fff0 !important;
}
/deep/ .ivu-drawer-content {
  width: 1%;
  height: 1%;
}
.jt1{
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  // top: 0;
  right: 0;
  background: #f0c026;
  border: 1px solid #00000026;
}
.jt {
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  right: 163px;
  background: #f0c026;
}
.one {
  position: relative;
  left: -200px;
}
#floatDivBoxs {
  width: 170px;
  background: #fff;
  position: fixed;
  top: 180px;
  right: 0;
  z-index: 999;
}
#floatDivBoxs .floatDtt {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: #f08326;
  color: #fff;
  font-size: 18px;
  text-indent: 22px;
  position: relative;
}
#floatDivBoxs .floatDqq {
  padding: 0 14px;
}
#floatDivBoxs .floatDqq li {
  height: 45px;
  line-height: 45px;
  // font-size: 15px;
  border-bottom: 1px solid #e3e3e3;
  padding: 0 0 0 50px;
}
a {
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}
#floatDivBoxs .floatDqq li a {
  color: #333;
}
#floatDivBoxs .floatDtxt {
  font-size: 18px;
  color: #333;
  padding: 12px 14px;
}
#floatDivBoxs .floatDtel {
  padding: 0 0 15px 10px;
  color: #f08326;
  font-size: 18px;
}
#floatDivBoxs .floatDbg {
  width: 100%;
  height: 20px;
  background: url("../../../assets/images/online_botbg.jpg") no-repeat;
  box-shadow: -2px 0 3px rgba(0, 0, 0, 0.25);
}
#floatDivBoxs .floatDewm {
  text-align: center;
  padding: 10px 0 5px 0;
  background: #ebebeb;
  color: #333;
}
#floatDivBoxs .floatDewm img {
  width: 106px;
  height: 106px;
}
/deep/ .ivu-modal-content {
  font-size: 18px;
}
/deep/ .ivu-modal-content .Modal {
  color: red !important;
}
/deep/ .ivu-modal-content .ModalA {
  color: red !important;
  text-decoration: underline;
  cursor: pointer;
}
/deep/.ivu-modal-body {
  font-size: 14px;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
.container {
  width: 100%;
  @include backgroundColor($_color);
  .body {
    background: url("../../../assets/images/BG.png") no-repeat 50%;
    height: 100vh;
    width: 100%;
    background-size: 100% 100%;
  }
  .total {
    width: 100%;
    display: flex;
    padding-bottom: 20px;
    justify-content: flex-end;

    .one {
      width: 500px;
      height: 550px;
      background: #fff;
      box-shadow: 0px 0px 30px 0px rgba(35, 21, 24, 0.35);
      border-radius: 20px;
      margin: 80px 190px 0 0;
      padding: 0 54px;
      p {
        font-size: 36px;
        font-weight: bold;
        color: #333;
        padding: 38px 0 0 0;
      }
      .pdw {
        font-size: 14px;
        font-weight: 600;
        position: absolute;
        color: #f00;
        margin: -59px 0 0 0;
        cursor: pointer;
      }
      .two {
        margin: 30px 0 30px 0;
        input {
          width: 390px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
      }
      .three {
        display: flex;
        flex-direction: row;
        input {
          width: 293px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
        .code {
          width: 156px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          margin: 0 0 0 10px;
        }
        /deep/ #verifyCanvas {
          width: 153px;
          height: 43px;
        }
      }
      .four {
        position: relative;
        display: flex;
        flex-direction: row;
        margin-top: 35px;
        .check1 {
          width: 19px;
          height: 19px;
          background: #fff;
          border-radius: 50%;
          border: 1px solid #c2c2c2;
          position: absolute;
          top: 0;
        }
        .check2 {
          width: 19px;
          height: 19px;
          background: #0099ff;
          border-radius: 50%;
          position: absolute;
          top: 0;
        }
        span {
          margin: 0 0 0 25px;
          font-weight: 500;
          color: #666;
          width: 50px;
        }
        button {
          @include backgroundColor($_color);
          width: 230px;
          height: 60px;
          border-radius: 5px;
          display: flex;
          margin: 0px 0 0 160px;
          line-height: 60px;
          cursor: pointer;
          border: none;
          justify-content: space-around;
          img {
            vertical-align: middle;
            margin: 14px 0 0 0px;
          }
          span {
            font-size: 24px;
            font-weight: 500;
            color: #fff;
          }
        }
      }
      .five {
        width: 460px;
        height: 70px;
        background: #f9f9f9;
        border-radius: 5px;
        text-align: center;
        margin: 37px -35px;
        span {
          font-size: 20px;
          font-weight: 500;
          line-height: 65px;
        }
        span:nth-child(1) {
          color: #333;
        }
        span:nth-child(2) {
          color: #f00;
          // @include color($_color);
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/signup/login.vue